var _       = require('underscore');
var $       = require('jquery');
var ui_templates = require("ui-templates");
var Core        = ui_templates.Core;
var InspectorGroup = ui_templates.InspectorGroup;

class SidebarPackageGeneratorForm extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'theme': 'dark'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__package__generator__form js-editor__sidebar__package__generator__form"></div>
        `;

        super.render();
    }

    //note: inspector view calls this
    addGroup() {
        return new InspectorGroup({
            target: this.$el,
            fields: {
                'theme': this._options.fields["theme"]
            }
        });
    }

    //note: inspector view calls this
    clear() {
        this.$el.html('');
    }
}

module.exports = SidebarPackageGeneratorForm;